<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="ENTIDADES" key="1">
        <a-row>
          <g-master name="entidades"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    modalWidth="80%"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID de entidad')">
                    <a-input style="width: 100%;"
                             v-decorator="['ent_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de entidad')"
                              :formItemConfig="fiOptions"
                              :decorator="['ent_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="tipo_entidad"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre de entidad')">
                    <a-input style="width: 100%;"
                             v-decorator="['ent_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nit')">
                    <a-input style="width: 100%;"
                             v-decorator="['ent_nit', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dirección principal')">
                    <a-input style="width: 100%;"
                             v-decorator="['ent_address', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['ent_status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="estado">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Pais')"
                              :formItemConfig="fiOptions"
                              :decorator="['ent_country', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :customSlots="['suffixIcon']"
                              :selectedObj.sync="dropdown.country"
                              :params="id_h_country"
                              ref="ent_country">
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country.equivalency]"
                           alt=""
                           v-if="dropdown.country && dropdown.country.equivalency">
                    </template>
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup endpoint="hierarchy_lookup"
                            :formItemConfig="fiOptions"
                            :label="$t('Ciudad')"
                            :decorator="['ent_city', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="{h_lookup_type: 'CIUDADES', use_code: true}"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Teléfono')">
                    <a-input style="width: 100%;"
                             v-decorator="['ent_phone', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'

  export default {
    data () {
      return {
        flags: FLAGS,
        dropdown: {
          country: {}
        },
        entidadSeleccionadaNombre: {},
        id_h_country: {
          h_lookup_type: 'PAISES',
          use_code: true
        },
        tipo_entidad: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        tipoEntidadSeleccionada: {},
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'legal_entities',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID entidad', dataIndex: 'ent_id', sorter: true},
              {title: 'Tipo de entidad', dataIndex: 'tipo_entidad', sorter: true},
              {title: 'Nombre entidad', dataIndex: 'ent_name', sorter: true},
              {title: 'Dirección principal', dataIndex: 'ent_address', sorter: true},
              {title: 'País', dataIndex: 'pais', sorter: true},
              {title: 'Ciudad', dataIndex: 'ciudad', sorter: true},
              {title: 'Nit', dataIndex: 'ent_nit', sorter: true},
              {title: 'Teléfono', dataIndex: 'ent_phone', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'ent_address'},
            {name: 'ent_city'},
            {name: 'ent_country'},
            {name: 'ent_digito'},
            {name: 'ent_id'},
            {name: 'ent_name'},
            {name: 'ent_nit'},
            {name: 'ent_phone'},
            {name: 'ent_status'},
            {name: 'ent_type'}
          ]
        },
        endpointExcel: 'entidades_/downloadExcel',
        fileNameExcel: 'Entidades',
        paramsT: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/LegalEntities/LegalEntities.vue